import React, { memo, useState, useCallback, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import Grid from '@material-ui/core/Grid'
import classNames from 'classnames'
import { useHistory, useLocation } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import ButtonBase from '@material-ui/core/ButtonBase'
import CircularProgress from '@material-ui/core/CircularProgress'

import styles from './styles'
import { Header, Content } from './components'
import { useArticleState, ArticleProvider } from './reducer'
import {
	ITag,
	TArticleIndexProps,
	EArticleSectionTypes,
	EArticleActionTypes,
	EEntity,
} from 'models'
import { RouteLeavingGuard } from 'components'
import { useHandleArticleMutation } from 'graphql/__generated__/graphql'

const useStyles = makeStyles(styles)

const CreateView: React.FunctionComponent<TArticleIndexProps> = () => {
	const history = useHistory()
	const classes = useStyles()
	const { t, i18n } = useTranslation()
	const [state, dispatch] = useArticleState()
	const [loading, toggle] = useState(false)
	const [createArticleMutationHandle] = useHandleArticleMutation()
	//const [openConfirmExitModal, setOpenConfirmExitModal] = useState(false)
	const [publish, setPublish] = React.useState(false)
	let routeLocation = useLocation()

	const {
		id,
		section,
		body,
		title,
		description,
		featuredImage,
		featuredVideo,
	} = state

	const confirmCloseArticle = useCallback(() => {
		history.push('/')
	}, [history])

	// const closeArticle = () => {
	// 	if (dataNeedsSaving()) {
	// 		console.log('if')
	// 		setOpenConfirmExitModal(true)
	// 	}
	// 	else {
	// 		console.log('else')
	// 		confirmCloseArticle()
	// 	}
	// }

	const publishArticle = () => {
		let error = false
		console.log({ body })

		switch (section) {
			case EArticleSectionTypes.post:
				if (!body || body.trim() === '') {
					error = true
					dispatch({
						type: EArticleActionTypes.setError,
						error: {
							post: true,
						},
					})
				}
				break
			case EArticleSectionTypes.article:
				let errorData = {
					title: false,
					body: false,
					featuredImage: false,
					description: false,
				}
				if (!title || title.trim() === '') {
					error = true
					errorData.title = true
				}
				if (!body || body.trim() === '') {
					error = true
					errorData.body = true
				}
				if (!description || description.trim() === '') {
					error = true
					errorData.description = true
				}
				if (!featuredImage && !featuredVideo) {
					error = true
					errorData.featuredImage = true
				}
				if (error)
					dispatch({
						type: EArticleActionTypes.setError,
						error: errorData,
					})
				break
		}
		if (!error) {
			const mutate = async () => {
				try {
					let data = state
					data.postingCompanyId =
						data.postAs === EEntity.company
							? data.postAsId
							: undefined
					delete data.author
					delete data.postAsId
					delete data.tagging
					delete data.section
					delete data.success
					delete data.error
					await createArticleMutationHandle({
						variables: {
							...data,
							language: i18n.language,
							id,
							isPost: section === EArticleSectionTypes.post,
							tags: data?.tags?.map((item: ITag) => item.id),
						},
					})
					setPublish(true)
					history.goBack()
				} catch (error) {
					console.error(error)
					toggle(false)
				}
			}
			mutate()
			toggle(true)
		}
	}

	//  Handle close browser button
	const dataNeedsSaving = useCallback(() => {
		if (!publish) {
			if (section === EArticleSectionTypes.post) {
				if (body && body.trim() !== '') {
					return true
				} else {
					return false
				}
			} else {
				if (
					(body && body.trim() !== '') ||
					(title && title.trim() !== '') ||
					(description && description.trim() !== '') ||
					featuredImage ||
					featuredVideo
				) {
					return true
				} else return false
			}
		}
	}, [
		body,
		publish,
		description,
		featuredImage,
		featuredVideo,
		section,
		title,
	])

	const handleWindowClose = (e: any) => {
		if (dataNeedsSaving()) {
			e.preventDefault()
			return (e.returnValue = '')
		}
	}

	useEffect(() => {
		window.addEventListener('beforeunload', handleWindowClose)
		return () => {
			window.removeEventListener('beforeunload', handleWindowClose)
		}
	})
	return (
		<>
			<Grid
				container
				justifyContent="center"
				classes={{ container: classes.flexGrow }}
			>
				<div className={classNames(classes.root)}>
					<Header
						closeArticle={() => {
							history.goBack()
						}}
					/>
					<Grid
						item
						xs={12}
						sm={8}
						md={6}
						lg={4}
						className={classNames(classes.container)}
					>
						<Content />
					</Grid>
					<ButtonBase
						className={classes.publishButton}
						onClick={publishArticle}
						disabled={loading}
					>
						{!loading &&
							(section === EArticleSectionTypes.post
								? t('Publish post')
								: t('Publish article'))}
						{loading && (
							<CircularProgress
								className={classes.loading}
								size={20}
							/>
						)}
					</ButtonBase>
				</div>
			</Grid>
			<RouteLeavingGuard
				navigate={confirmCloseArticle}
				shouldBlockNavigation={location =>
					location.pathname !== routeLocation.pathname &&
					!!dataNeedsSaving()
				}
				when={true}
			/>
		</>
	)
}

const Create = (props: any) => {
	const {
		location: { state },
	} = props
	return (
		<ArticleProvider
			article={(state && state.article) || null}
			reset={state && state.reset}
		>
			<CreateView {...props} />
		</ArticleProvider>
	)
}
export default memo(Create)
